import { render, staticRenderFns } from "./EditPaperPages.vue?vue&type=template&id=6aca2bad&scoped=true"
import script from "./EditPaperPages.vue?vue&type=script&lang=js"
export * from "./EditPaperPages.vue?vue&type=script&lang=js"
import style0 from "./EditPaperPages.vue?vue&type=style&index=0&id=6aca2bad&prod&scoped=true&lang=css"
import style1 from "./EditPaperPages.vue?vue&type=style&index=1&id=6aca2bad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca2bad",
  null
  
)

export default component.exports